<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para-a"><a id="page_iv"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="linespace"> </p>
<p class="para-a"><span class="smallcaps">FINAL EXAM</span>. Copyright © 2009 by Maggie Barbieri. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="para"> </p>
<p class="para-a"><a href="http://www.minotaurbooks.com" target="_blank">www.minotaurbooks.com</a></p>
<p class="para"> </p>
<p class="center-para-a">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<p class="para-a">Barbieri, Maggie.</p>
<p class="indent-para-a">Final exam / Maggie Barbieri. — 1st ed.</p>
<p class="indent-para-a">     p. cm.</p>
<p class="indent-para-a">ISBN 978-0-312-37677-2</p>
<p class="indent-para-a">1. Bergeron, Alison (Fictitious character)—Fiction. 2. Crawford, Bobby<br/>(Fictitious character)—Fiction. 3. Women college teachers—Fiction.<br/>4. English teachers—Fiction. 5. College students—Fiction. 6. Police—<br/>New York (State)—New York—Fiction. 7. Missing persons—Fiction.<br/>I. Title.</p>
<p class="indent-para-a">PS3602.A767F56 2009</p>
<p class="indent-para-a">813'.6—dc22</p>
<p class="right-para">2009028473</p>
<p class="linespace"> </p>
<p class="para-a">First Edition: December 2009</p>
<p class="para"> </p>
<p class="para-a">10    9    8    7    6    5    4    3    2    1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?34ffbca1